/**
 * Nội dung mã QR của một vùng trồng: SỐ ĐIỆN THOẠI của hộ ghép LIỀN MÃ VÙNG
 * TRỒNG, không dấu cách và không ký tự phân cách nào ở giữa — vd
 * `0912345678MVT001`.
 *
 * Mọi khoảng trắng người dùng gõ lẫn vào số điện thoại ("091 234 5678") hay lọt
 * vào mã vùng đều bị bỏ hẳn: máy quét trả về đúng chuỗi ký tự trong mã, nên còn
 * một dấu cách là chuỗi quét ra khác chuỗi hệ thống chờ đợi và bên nhận tách sai
 * hai phần.
 *
 * Cố ý KHÔNG lọc các ký tự khác (dấu `+`, `-`, `()` trong số điện thoại): đó là
 * dữ liệu hộ đã khai, bỏ đi là tự sửa số điện thoại của họ.
 *
 * Trả về chuỗi rỗng khi thiếu bất kỳ phần nào: một mã chỉ có `0912345678` hoặc
 * chỉ có `MVT001` là mã quét ra dữ liệu sai, thà không dựng QR để màn hình nói
 * rõ đang thiếu gì.
 */
export function growerAreaQrValue(
    phone: string | null | undefined,
    areaCode: string | null | undefined,
): string {
    const normalizedPhone = stripWhitespace(phone)
    const normalizedCode = stripWhitespace(areaCode)
    if (!normalizedPhone || !normalizedCode) return ''
    return `${normalizedPhone}${normalizedCode}`
}

function stripWhitespace(value: string | null | undefined): string {
    return (value ?? '').replace(/\s+/g, '')
}
